import { IPeriod } from "../models/overview/dashboard";
import { DashboardPeriodOptions } from "./enums";

const BaseKeys = (key: string) => {
  return {
    all: key,
    getById: (id?: number) => [key, id],
    getAll: (args?: any) => [key, "list", ...args],
    getAndCountAll: (args?: any) => [key, "related", ...args],
    getAllNetwork: (args?: any) => [key, "network", ...args],
    getAvaible: (args?: any) => [key, "available", ...args],
    count: (args?: any) => [key, "total", ...args],
    save: () => [key, "save"],
    update: () => [key, "update"],
    create: () => [key, "create"],
    delete: () => [key, "delete"],
  };
};

export const ShipmentResourceKeys = {
  all: "shipment.resource",
  getShipmentNetwork: (id?: number) => [ShipmentResourceKeys.all, "network.get", id],
  getResource: (resource: string, args?: any) => [resource, ShipmentResourceKeys.all, args],
};

export const CertificationKeys = {
  ...BaseKeys("certifications"),
  approve: (id?: number) => [CertificationKeys.all, "approve", id],
};

export const TimesheetKeys = {
  ...BaseKeys("timesheet"),
  getWidgets: (args?: any) => ["widgets", ...args],
};

export const WarehouseKeys = {
  ...BaseKeys("warehouses"),
};

export const AccountKeys = {
  ...BaseKeys("accounts"),
};

export const AgentKeys = {
  ...BaseKeys("agents"),
  all: "agents",
  invite: (id?: number) => [AgentKeys.all, "invite", id],
  checkToken: (token?: string) => [AgentKeys.all, "checkToken", token],
  revoke: (companyId?: string) => [AgentKeys.all, "revoke", companyId],
};

export const WarehouseMapsKeys = {
  ...BaseKeys("warehouseMaps"),
};

export const CustomerKeys = {
  ...BaseKeys("customers"),
  invite: (id?: number) => [SupplierKeys.all, "invite", id],
};

export const MilestoneKeys = {
  all: "milestones",
};

export const DocumentKeys = {
  all: "documents",
  create: () => [DocumentKeys.all, "create"],
  clear: () => [DocumentKeys.all, "clear"],
  upload: () => [DocumentKeys.all, "upload"],
  uploadMultiple: () => [DocumentKeys.all, "uploadMultiple"],
  removeArchive: () => [DocumentKeys.all, "removeArchive"],
  update: () => [DocumentKeys.all, "update"],
};

export const OrderKeys = {
  ...BaseKeys("orders"),
};

export const TaskKeys = {
  ...BaseKeys("tasks"),
  cancelFromDespatch: () => [TaskKeys.all, "cancel-despatch"],
  publishFromDespatch: () => [TaskKeys.all, "publish-despatch"],
  unpublishFromDespatch: () => [TaskKeys.all, "unpublish-despatch"],
};

export const TaskTypeKeys = {
  ...BaseKeys("tasks"),
};

export const AvailabilityKeys = {
  ...BaseKeys("availabilities"),
};

export const PortKeys = {
  ...BaseKeys("ports"),
};

export const CountryKeys = {
  all: "countries",
};

export const RoleKeys = {
  ...BaseKeys("roles"),
};

export const ApplicationKeys = {
  ...BaseKeys("applications"),
};

export const SupplierKeys = {
  ...BaseKeys("suppliers"),
  invite: (id?: number) => [SupplierKeys.all, "invite", id],
};

export const OfficeKeys = {
  ...BaseKeys("offices"),
};

export const NotifyPartyKeys = {
  all: "notify.parties",
};

export const JobReportKeys = {
  ...BaseKeys("job.reports"),
};

export const PurchaseOrderKeys = {
  ...BaseKeys("purchase.order"),
  getAvailable: (args?: any) => [PurchaseOrderKeys.all, "available", ...args],
  getAvailableShipments: (args?: any) => [PurchaseOrderKeys.all, "available", ...args],
  getMilestones: (args?: any) => [PurchaseOrderKeys.all, "milestones", ...args],
};

export const CartonKeys = {
  all: "cartons",
  generateReport: () => [BookingKeys.all, "generate", "report"],
  generateSSCC: () => [BookingKeys.all, "generate", "sscc"],
  generateMultipleSSCC: () => [BookingKeys.all, "generate", "multiple", "sscc"],
};

export const BookingKeys = {
  ...BaseKeys("booking"),
  cancel: () => [BookingKeys.all, "cancel"],
  receive: () => [BookingKeys.all, "receive"],
  underReview: () => [BookingKeys.all, "underreview"],
  getCartons: (id: number) => [BookingKeys.all, id, CartonKeys.all],
  getOrders: (id: number) => [BookingKeys.all, id, PurchaseOrderKeys.all],
  getExportById: (id: number) => [BookingKeys.all, "export", id],
  import: () => [BookingKeys.all, "import"],
  updateDocuments: () => [BookingKeys.all, "update", DocumentKeys.all],
  uploadDocument: () => [BookingKeys.all, "upload", DocumentKeys.all],
  downloadDocuments: () => [BookingKeys.all, "download", DocumentKeys.all],
  downloadBookingFile: () => [BookingKeys.all, "download", "file"],
  downloadBookingFiles: () => [BookingKeys.all, "download", "files"],
  sendBookingFileMods: () => [BookingKeys.all, "send", "file"],
  downloadCipl: () => [BookingKeys.all, "download", "cipl"],
  downloadCiplCsv: () => [BookingKeys.all, "download", "cipl", "csv"],
  downloadCartonLogs: () => [BookingKeys.all, "download", CartonKeys.all, "logs"],
  getInvoiceList: (args?: any) => [BookingKeys.all, "invoices", ...args],
};

export const ShipmentKeys = {
  ...BaseKeys("shipment"),
  sendMail: (ids: number[]) => [ShipmentKeys.all, "mail", ...ids],
};

export const ReportProductsKeys = {
  ...BaseKeys("reportProducts"),
};

export const ProductKeys = {
  ...BaseKeys("products"),
  all: "products",
  count: (args?: any) => ["count", ProductKeys.all, ...args],
  delete: (id: number) => ["delete", ProductKeys.all, id],
  getAllProducts: (args?: any) => ["getAll", ProductKeys.all, ...args],
};

export const DespatchKeys = {
  ...BaseKeys("despatch"),
  getProducts: (id: number) => [DespatchKeys.all, id, ProductKeys.all],
  getStatuses: () => [DespatchKeys.all, "statuses"],
  getAvailableProducts: (args?: any) => [DespatchKeys.all, "available", ProductKeys.all, ...args],
  printDeliveryDocket: () => [DespatchKeys.all, "print", "delivery.docket"],
};

export const LocationsKeys = {
  ...BaseKeys("locations"),
};

export const ExpensesKeys = {
  ...BaseKeys("expenses"),
};

export const SignatureKeys = {
  ...BaseKeys("signature"),
};

export const TimezoneKeys = {
  ...BaseKeys("timezones"),
};

export const ShipmentInvoicesKeys = {
  ...BaseKeys("shipmentInvoicesKeys"),
  delete: (id: number) => [ShipmentInvoicesKeys.all, id],
  uploadInvoices: () => [ShipmentInvoicesKeys.all, "upload.invoices"],
};

export const ReportsKeys = {
  ...BaseKeys("reports"),
  getShipments: (args?: any) => [ReportsKeys.all, "shipments", ...args],
};

export const ReportGroupKeys = {
  ...BaseKeys("reportGroup"),
};

export const CheckListKeys = {
  ...BaseKeys("checkList"),
};

export const UserKeys = {
  ...BaseKeys("user"),
};

export const StaffKeys = {
  ...BaseKeys("staff"),
};

export const ChainReportKeys = {
  ...BaseKeys("chainReportKeys"),
  sendMail: (args?: any) => [ReportsKeys.all, "send.mail", ...args],
  generateReport: (args?: any) => [ReportsKeys.all, "generate.reports", ...args],
  generateOldReport: (args?: any) => [ReportsKeys.all, "generate.reports.olds", ...args],
  getAllLCR: (args?: any) => [ReportsKeys.all, "get.all.lcr", ...args],
};

export const ContainerKeys = {
  ...BaseKeys("containers"),
};

export const FleetKeys = {
  ...BaseKeys("fleet"),
};

export const RoutePlannerKeys = {
  all: "route",
  createFleet: () => [RoutePlannerKeys.all, FleetKeys.all, "create"],
  updateFleet: () => [RoutePlannerKeys.all, FleetKeys.all, "update"],
  deleteFleet: () => [RoutePlannerKeys.all, FleetKeys.all, "delete"],
  createDriver: () => [RoutePlannerKeys.all, UserKeys.all, "create"],
  updateDriver: () => [RoutePlannerKeys.all, UserKeys.all, "update"],
  deleteDriver: () => [RoutePlannerKeys.all, UserKeys.all, "delete"],
  createTask: () => [RoutePlannerKeys.all, DespatchKeys.all, "create"],
  updateTask: () => [RoutePlannerKeys.all, DespatchKeys.all, "update"],
  deleteTask: () => [RoutePlannerKeys.all, DespatchKeys.all, "delete"],
  createTaskList: () => [RoutePlannerKeys.all, DespatchKeys.all, "create", "list"],
  deleteTaskList: () => [RoutePlannerKeys.all, DespatchKeys.all, "delete", "list"],
};

export const BranchKeys = {
  ...BaseKeys("branch"),
};

export const FleetTypeKeys = {
  ...BaseKeys("fleet.type"),
};

export const ProjectKeys = {
  ...BaseKeys("project"),
  uploadCsv: () => [ProjectKeys.all, "upload.csv"],
};

export const UserProjectKeys = {
  ...BaseKeys("user.project"),
  updateProjectView: () => [UserProjectKeys.all, "update.project"],
};

export const CronjobKeys = {
  ...BaseKeys("cronjob"),
};

export const FileImportKeys = {
  ...BaseKeys("file.import"),
  findByTableName: (args?: any) => [ProjectKeys.all, "find.by.table.name", ...args],
};

export const CurrenciesKeys = {
  ...BaseKeys("currencies"),
};

export const BrandKeys = {
  ...BaseKeys("brand"),
  delete: (id: number) => ["brand", "delete", id],
  deleteList: (ids: number[]) => ["brand", "delete", ...ids],
  generatePreview: () => ["brand", "generate", "preview"],
};

export const LoadingCostKeys = {
  ...BaseKeys("loading.cost"),
};

export const DashboardKeys = {
  all: "dashboard",
  getContaintersGraphInbound: (
    customDate: Date | undefined,
    customPeriod: IPeriod | undefined,
    selectedPeriod: DashboardPeriodOptions
  ) => [DashboardKeys.all, "containers.inbound", customDate, customPeriod, selectedPeriod],
  getContaintersGraphAtPort: (
    customDate: Date | undefined,
    customPeriod: IPeriod | undefined,
    selectedPeriod: DashboardPeriodOptions
  ) => [DashboardKeys.all, "containers.atport", customDate, customPeriod, selectedPeriod],
  getContaintersGraphAtDC: (
    customDate: Date | undefined,
    customPeriod: IPeriod | undefined,
    selectedPeriod: DashboardPeriodOptions
  ) => [DashboardKeys.all, "containers.atdc", customDate, customPeriod, selectedPeriod],
  getContaintersGraphDistributionByDestination: (
    customDate: Date | undefined,
    customPeriod: IPeriod | undefined,
    selectedPeriod: DashboardPeriodOptions
  ) => [
    DashboardKeys.all,
    "containers.distribution.by.destination",
    customDate,
    customPeriod,
    selectedPeriod,
  ],
  getContaintersGraphStatuses: (
    customDate: Date | undefined,
    customPeriod: IPeriod | undefined,
    selectedPeriod: DashboardPeriodOptions
  ) => [
    DashboardKeys.all,
    "containers.grouped.by.status",
    customDate,
    customPeriod,
    selectedPeriod,
  ],
  getContaintersGraphByArrivalDate: (
    customDate: Date | undefined,
    customPeriod: IPeriod | undefined,
    selectedPeriod: DashboardPeriodOptions
  ) => [DashboardKeys.all, "containers.by.arrival.date", customDate, customPeriod, selectedPeriod],
  getOrdersGraphPurchaseOrders: (
    customDate: Date | undefined,
    customPeriod: IPeriod | undefined,
    selectedPeriod: DashboardPeriodOptions
  ) => [
    DashboardKeys.all,
    "purchase.orders.count.pending",
    customDate,
    customPeriod,
    customDate,
    customPeriod,
    selectedPeriod,
  ],
  getOrdersGraphShipByDate: (
    customDate: Date | undefined,
    customPeriod: IPeriod | undefined,
    selectedPeriod: DashboardPeriodOptions
  ) => [
    DashboardKeys.all,
    "purchase.orders.count.past.ship.by.date",
    customDate,
    customPeriod,
    selectedPeriod,
  ],
  getOrdersGraphPoStatuses: (
    customDate: Date | undefined,
    customPeriod: IPeriod | undefined,
    selectedPeriod: DashboardPeriodOptions
  ) => [
    DashboardKeys.all,
    "purchase.orders.grouped.by.status",
    customDate,
    customPeriod,
    selectedPeriod,
  ],
  getLastReceivedPurchaseOrders: (
    customDate: Date | undefined,
    customPeriod: IPeriod | undefined,
    selectedPeriod: DashboardPeriodOptions
  ) => [
    DashboardKeys.all,
    "purchase.orders.last.received",
    customDate,
    customPeriod,
    selectedPeriod,
  ],
  getOrdersGraphPoConfirmedVSPoReceived: (
    customDate: Date | undefined,
    customPeriod: IPeriod | undefined,
    selectedPeriod: DashboardPeriodOptions
  ) => [
    DashboardKeys.all,
    "purchase.orders.confirmed.vs.received",
    customDate,
    customPeriod,
    selectedPeriod,
  ],
  getProductsGraphOrigin: (
    customDate: Date | undefined,
    customPeriod: IPeriod | undefined,
    selectedPeriod: DashboardPeriodOptions
  ) => [DashboardKeys.all, "products.origin", customDate, customPeriod, selectedPeriod],
  getProductsGraphMostRequested: (
    customDate: Date | undefined,
    customPeriod: IPeriod | undefined,
    selectedPeriod: DashboardPeriodOptions
  ) => [DashboardKeys.all, "products.most.requested", customDate, customPeriod, selectedPeriod],
  getProductsGraphRunningOutOfStock: (
    customDate: Date | undefined,
    customPeriod: IPeriod | undefined,
    selectedPeriod: DashboardPeriodOptions
  ) => [
    DashboardKeys.all,
    "products.running.out.of.stock",
    customDate,
    customPeriod,
    selectedPeriod,
  ],
  getShipmentsTrackeds: (
    customDate: Date | undefined,
    customPeriod: IPeriod | undefined,
    selectedPeriod: DashboardPeriodOptions
  ) => [DashboardKeys.all, "shipments.trackeds", customDate, customPeriod, selectedPeriod],
  getShipmentGraphCountPerTime: (
    customDate: Date | undefined,
    customPeriod: IPeriod | undefined,
    selectedPeriod: DashboardPeriodOptions
  ) => [DashboardKeys.all, "shipments.count.per.time", customDate, customPeriod, selectedPeriod],
  getShipmentsGraphStatuses: (
    customDate: Date | undefined,
    customPeriod: IPeriod | undefined,
    selectedPeriod: DashboardPeriodOptions
  ) => [DashboardKeys.all, "shipments.grouped.by.status", customDate, customPeriod, selectedPeriod],
};

export const CommodityCodeKeys = {
  ...BaseKeys("commodity.code"),
  createList: () => [CommodityCodeKeys.all, "create", "list"],
  switchStatus: () => [CommodityCodeKeys.all, "switch"],
  getSections: () => [CommodityCodeKeys.all, "sections"],
  getRegions: () => [CommodityCodeKeys.all, "regions"],
};

export const CarrierKeys = {
  ...BaseKeys("carrier"),
};

export const MemberKeys = {
  ...BaseKeys("members"),
};

export const CitizenshipKeys = {
  ...BaseKeys("citizenships"),
};

export const TranslateKeys = {
  ...BaseKeys("translates"),
};

export const ServicesKeys = {
  ...BaseKeys("services"),
};

export const MaterialsKeys = {
  ...BaseKeys("materials"),
};

export const UploadCentreKeys = {
  ...BaseKeys("upload.centre"),
};

export const ContainerConferenceKeys = {
  ...BaseKeys("container.conference"),
  getCrossDock: (args?: any) => [ContainerConferenceKeys.all, "crossdock", ...args],
};

export const TransshipmentKeys = {
  ...BaseKeys("transshipment"),
};

export const CustomerPortalKeys = {
  ...BaseKeys("customer.portal"),
  getMilestones: (args?: any) => [CustomerPortalKeys.all, "milestones", ...args],
  getOrders: (args?: any) => [CustomerPortalKeys.all, "orders", ...args],
  getQuotes: (args?: any) => [CustomerPortalKeys.all, "quotes", ...args],
};

export const DestinationKeys = {
  ...BaseKeys("destination"),
};

export const ModeKeys = {
  ...BaseKeys("mode"),
};

export const CustomerPortalEstimatedInventoryKeys = {
  ...BaseKeys("estimated.inventory"),
};

export const ItemJobKeys = {
  ...BaseKeys("itemJob"),
  getInventory: (args?: any) => [ItemJobKeys.all, "inventory", ...args],
};

export const ReportManagement = {
  ...BaseKeys("reportManagement"),
  deleteSubscription: (args?: any) => [ReportManagement.all, "deleteSubscription", ...(args ?? [])],
  updateSubscription: (args?: any) => [ReportManagement.all, "updateSubscription", ...(args ?? [])],
  createSubscription: (args?: any) => [ReportManagement.all, "createSubscription", ...(args ?? [])],
};

export const RoomsKeys = {
  ...BaseKeys("rooms"),
};

export const JobHistoriesKeys = {
  ...BaseKeys("jobs.histories"),
};
export const JobFolderKeys = {
  ...BaseKeys("jobs.folders"),
  getByJobId: (id?: number) => [JobFolderKeys.all, id],
};

export const JobKeys = {
  ...BaseKeys("jobs"),
  getEstimates: (jobId?: number | string) => [JobKeys.all, "estimate", jobId],
};

export const CommentKeys = {
  ...BaseKeys("comment"),
};

export const ActivitiesKeys = {
  ...BaseKeys("activities"),
};

export const ModeJobKeys = {
  ...BaseKeys("mode.jobs"),
};

export const ChecklistSealsKeys = {
  ...BaseKeys("checklist.seals"),
  createChecked: () => [ChecklistSealsKeys.all, "checked"],
  getByRelation: () => [ChecklistSealsKeys.all, "relation"],
};

export const SubcontractorKeys = {
  ...BaseKeys("subcontractors"),
};

export const TeamKeys = {
  ...BaseKeys("teams"),
  createCrew: () => [...TeamKeys.create(), "despatch-crew"],
  persistCrewChanges: () => [...TeamKeys.update(), "despatch-crew-changes"],
};

export const JobOrderKey = {
  ...BaseKeys("job.orders"),
};

export const JobQuoteKey = {
  ...BaseKeys("job.quotes"),
};

export const LanguageKeys = {
  ...BaseKeys("languages"),
};

export const StorageBoxKeys = {
  ...BaseKeys("storagebox"),
};

export const UserCompanyKeys = {
  ...BaseKeys("user.company"),
};

export const CompanyKeys = {
  ...BaseKeys("companies"),
};

export const ContactListKeys = {
  ...BaseKeys("contact.list"),
};

export const FoldersKeys = {
  ...BaseKeys("folders"),
  getOrderFolders: (jobId?: number | string) => [FoldersKeys.all, "order.folders", jobId],
  updateOrderFolder: (jobId?: number | string) => [FoldersKeys.all, "update.order.folders", jobId],
  mutateFolders: () => [FoldersKeys.create(), "mutate.folders"],
};

export const CompanySecurityKeys = {
  all: "security.company",
  getByCompanyId: (companyId?: number) => [CompanySecurityKeys.all, companyId],
  update: () => [CompanySecurityKeys.all, "update"],
};

export const LoginSessionKeys = {
  ...BaseKeys("sessions"),
};

export const ShipmentHistoriesKeys = {
  ...BaseKeys("shipment.histories"),
};
